import { Service, inject } from '@angular/core'
import {
  GetNotificationsResponse,
  Notification,
  DeleteEntityResponse,
  SetNotificationReadBody,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class NotificationApiService {
  private readonly api = inject(ApiService)

  getNotifications(init?: RequestInit) {
    return this.api.protectedFetchJson<GetNotificationsResponse>(`notifications`, { ...init })
  }

  setNotificationRead(notificationId: string, body: SetNotificationReadBody, init?: RequestInit) {
    return this.api.protectedFetchJson<Notification>(`notifications/${notificationId}/read`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }

  deleteNotification(notificationId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(`notifications/${notificationId}`, {
      method: 'DELETE',
      ...init,
    })
  }
}
